import { Button, Dropdown, FormControl, Checkbox } from "@uhg-harmony/react";
import { type Dispatch, type SetStateAction } from "react";
import { buttonDefaults } from "../ui/Button";
import type { PublishOption } from "../../types/optionTypes";
import "./action-bar.css";

type ActionBarProps = {
  onPublish: () => void;
  onRename: () => void;
  onClone: () => void;
  onMove: () => void;
  onDelete: () => void;
  onSaveDraft: () => void;
  onHome: () => void;
  onActivate: () => void;
  onDeactivate: () => void;
  canDeactivate: boolean;
  publishVersion: PublishOption[];
  selectedPublishVersion: PublishOption;
  setSelectedPublishVersion: Dispatch<SetStateAction<PublishOption>>;
  onVersionChangeByUser?: (version: PublishOption) => void;
  isActivePublishVersion: boolean;
  isDraftSelected: boolean;
  isChecked: boolean;
  isPublishDisabled?: boolean;
  isRenameDisabled?: boolean;
  isCloneDisabled?: boolean;
  isMoveDisabled?: boolean;
  isDeleteDisabled?: boolean;
  isDeleting?: boolean;
  isSaveAsDraftDisabled?: boolean;
  isDropdownDisabled?: boolean;
  isHomeDisabled?: boolean;
};

const buttonProps = buttonDefaults;

const ActionBar = ({
  onPublish,
  onRename,
  onClone,
  onMove: _onMove,
  onDelete,
  onSaveDraft,
  onHome,
  onActivate,
  onDeactivate,
  canDeactivate,
  publishVersion,
  selectedPublishVersion,
  setSelectedPublishVersion,
  onVersionChangeByUser,
  isActivePublishVersion,
  isDraftSelected,
  isChecked,
  isPublishDisabled = false,
  isRenameDisabled = false,
  isCloneDisabled = false,
  isMoveDisabled: _isMoveDisabled = false,
  isDeleteDisabled = false,
  isDeleting = false,
  isSaveAsDraftDisabled = false,
  isDropdownDisabled = false,
  isHomeDisabled = false,
}: ActionBarProps) => (
  <>
    <div className="row">
      <div className="col-4-25-l">
        {!isDropdownDisabled && (
          <div className="action-group">
            <div className="action-field">
              <Dropdown
                aria-label="Publish version"
                type="single"
                items={publishVersion}
                value={selectedPublishVersion}
                onChange={(v: PublishOption) => {
                  setSelectedPublishVersion(v);
                  onVersionChangeByUser?.(v);
                }}
                showClearButton={false}
                placeholderText=""
                disabled={isDropdownDisabled}
              />
            </div>

            {!isDraftSelected && (
              <FormControl
                id="active-flag"

                disabled={isActivePublishVersion && !canDeactivate}
              >
                <Checkbox
                  id="active-flag"
                  checked={isActivePublishVersion || isChecked}
                  disabled={isActivePublishVersion && !canDeactivate}
                  onChange={() => {
                    if (isActivePublishVersion && canDeactivate) {
                      onDeactivate();
                    } else if (!isActivePublishVersion) {
                      onActivate();
                    }
                  }}
                >
                  Active
                </Checkbox>
              </FormControl>
            )}
          </div>
        )}
      </div>
      <div className="col-4-50-m">
        <div className="action-group action-group--buttons">
          <Button {...buttonProps} onPress={onPublish} variant="primary" disabled={isPublishDisabled}>
            Publish
          </Button>
          <Button {...buttonProps} onPress={onRename} variant="primary" disabled={isRenameDisabled}>
            Rename
          </Button>
          <Button {...buttonProps} onPress={onClone} variant="primary" disabled={isCloneDisabled}>
            Clone
          </Button>
          {/* Move button hidden until feature is implemented
          <Button {...buttonProps} onPress={onMove} variant="secondary" disabled={isMoveDisabled}>
            Move
          </Button>
          */}
          <Button {...buttonProps} onPress={onDelete} variant="destructive" disabled={isDeleteDisabled || isDeleting}>
            Delete
          </Button>
        </div>
      </div>
      <div className="col-4-25-r">
        <div className="action-group action-group--end">

          <Button {...buttonProps} variant="primary" disabled={isSaveAsDraftDisabled} onPress={onSaveDraft}>
            <span className="btn-text-full">Save as Draft</span>
            <span className="btn-text-short">Save Draft</span>
          </Button>
          <Button {...buttonProps} disabled={isHomeDisabled} onPress={onHome}>
            Home
          </Button>
        </div>
      </div>
    </div>
  </>
);

export default ActionBar;